/**
 * A span of minutes in the reader's own words: "1 uur", "7 days", "15分钟".
 *
 * Intl names the unit, so no locale file has to. `i18n/index.ts` registers this
 * as the `minutes` format, which is how a sentence says `{{expiry, minutes}}`.
 */
const UNITS = [
  ['day', 1440],
  ['hour', 60],
] as const;

export const formatMinutes = (minutes: number, language: string | undefined): string => {
  // Only a unit that says the span exactly to one decimal: a notice reading
  // "up to 1 hour" for 61 minutes would promise less than is kept.
  const [unit, size] =
    UNITS.find(([, size]) => minutes >= size && (minutes * 10) % size === 0) ?? ['minute', 1];

  return new Intl.NumberFormat(language, {
    style: 'unit',
    unit,
    unitDisplay: 'long',
    maximumFractionDigits: 1,
  }).format(minutes / size);
};
